import { NgModule } from '@angular/core';
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { jqxComboBoxComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxcombobox';
import { jqxInputComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxinput';
import { jqxScrollViewComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxscrollview';
import { jqxChartComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxchart';
import{ jqxMenuComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxmenu';

import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [jqxGridComponent, jqxComboBoxComponent, jqxInputComponent, jqxScrollViewComponent, 
        jqxChartComponent, jqxMenuComponent],
    imports: [
        FormsModule
    ], 
    exports: [jqxGridComponent, jqxComboBoxComponent, jqxInputComponent,jqxScrollViewComponent, 
        jqxChartComponent, jqxMenuComponent]
})
export class JqWidgetsModule { }